import React  from "react";
import { Box, Grid } from "@mui/material";
import { CourseItems } from "..";
import PropTypes from 'prop-types';
import PopupLoginRequired from '../Popup/PopupLoginRequired';
const CourseCard = ({courses, maxCoursePerRow= 4, authenticated = false}) => {
    const [openLoginPopup, setOpenLoginPopup] = React.useState(false);
    const maxSizeOfCourseItem = 12 / maxCoursePerRow;
    return (
    <Box>
        <Grid 
          container
          spacing={4}
          justifyContent={'center'}
        >
            {courses.map((item, index) => (
                <Grid 
                    item 
                    xs={12} sm={6} md={4} xl={maxSizeOfCourseItem} 
                    key={item.id}
                >
                    <CourseItems 
                        course={item} 
                        index={index} 
                        authenticated={authenticated}
                        setOpenLoginPopup={setOpenLoginPopup}   
                    />
                </Grid>
            ))}
        </Grid>
        <PopupLoginRequired
            open={openLoginPopup} 
            onClose={() => setOpenLoginPopup(false)} 
        />
    </Box>
    )
}

CourseCard.propTypes = {
    courses: PropTypes.array.isRequired,
    authenticated: PropTypes.bool,
    maxCoursePerRow: PropTypes.number,
    openLoginPopup : PropTypes.func,
};
export default CourseCard;

  
  